module.exports = __webpack_public_path__ + "static/media/delayed_document.e7b871aa.svg";